<template>
  <div>
    <div class="container" id="userManagement">
      <div class="row mt-5 mb-1 " id="userManagement-row">
        <h5 class = "col" id="userManagement-col">
          {{ 'USER_MANAGEMENT' | translate }}
          <button type="button" class="btn btn-primary btn-sm ml-2"  v-on:click="openCreateEditDialog()" id="userManagement-button">
            <i class="fa fa-user-plus" id="userManagement-newUser"/> {{ 'ADD_NEW_USER' | translate }}
          </button>
        </h5>

        <div class="col-lg-5 mb-2" id="userManagement-rightCol">
          <div class="input-group input-group-sm" id="userManagement-inputGroup">
            <input :placeholder="'SEARCH_BY_NAME_USERNAME_EMAIL' | translate" class="form-control  border-right-0" name="input-name"
                   type="search" id="search-user" v-model="filter" v-on:keyup="updateFilters">
            <span class="input-group-append" id="userManagement-searchUser-span">
                <div class="input-group-text bg-transparent" id="userManagement-searchIcon"><i class="fa fa-search" id="userManagement-searchData"/></div>
              </span>
          </div>
        </div>
      </div>
      <div class="text-right mb-2">
        <strong :style="{visibility: userCount && loaded ? 'visible' : 'hidden'}">
        {{ 'COUNT' | translate }}: {{ userCount }}</strong>
      </div>
      <div class="alert alert-success alert-dismissible" v-if="successMessage">
        {{ successMessage }}
        <button type="button" class="close" @click="dismissAlertSuccess()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="alert alert-danger alert-dismissible" v-if="errorMessage">
        {{ errorMessage }}
        <button type="button" class="close" @click="dismissAlertError()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="mt-3" id="userManagement-table">
        <table class="table table-striped table-hover users-table" id="userManagement-userTable">
          <thead id="userManagement-tableHead">
            <tr>
              <th class="tcol-20">{{ 'USERNAME' | translate }}</th>
              <th class="tcol-20">{{ 'EMAIL' | translate }}</th>
              <th class="tcol-14">{{ 'NAME' | translate }}</th>
              <th class="tcol-14">{{ 'ROLES' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          
          <div class="cm-loader" v-if="!loaded">
            <custom-spinner></custom-spinner>
          </div>

          <tbody v-if="loaded && availableUsers.length" id="userManagement-tableBody">
            <tr v-for="(user, index) in availableUsers">
              <td class="font-weight-bold">{{ user.username}}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.firstName }} {{ user.lastName }}</td>
              <td>{{ getRolesAsString(userRoles[user.username])}}</td>
              <td class="text-right" :id="'userManagement-tableData-of-'+ user.username">
                <button type="button" class="btn btn-success btn-sm"
                        v-on:click="openEditRolesDialog(user, index)" :id="'userManagement-tableButton-SucessRole-' + user.username">
                  {{ 'ROLES' | translate }}
                </button>
                <button type="button" class="btn btn-success btn-sm"
                        v-on:click="openCreateEditDialog(user, index)" :id="'userManagement-tableButton-SucessEdit-' + user.username">
                  {{ 'EDIT' | translate }}
                </button>
                <button type="button" class="btn btn-default btn-sm text-danger"
                        v-on:click="openDeleteConfirmationDialog(user)" :id="'userManagement-tableButton-Delete-' + user.username">
                  <i class="fa fa-trash" :id="'userManagement-tableButton-Delete-Data-' + user.username"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="loaded && !availableUsers.length" class="text-center mt-4"> {{'NO_USERS_FOUND' | translate }}</div>
          <pagination-list
            v-if="loaded"
            v-model="currentPage"
            v-bind:currentPage="currentPage"
            v-bind:totalCount="userCount"
            v-bind:pageSize="maxPerPage"
          ></pagination-list>
      </div>
    </div>

    <vodal :show="showCreateEditDialog" animation="rotate" :width="addEditDialogWidth" @hide="showCreateEditDialog = false" v-bind:closeOnEsc="true"
           v-bind:closeOnClickMask="false" v-bind:customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}" id="userManagement-createUser">
      <h4 class="mb-4" v-if="currentUser.id == null">{{ 'CREATE_USER' | translate }}</h4>
      <h4 class="mb-4" v-else>{{ 'EDIT_USER' | translate }}</h4>
      <form @submit="checkForm">
        <div class="alert alert-danger" v-if="modalErrorMessage">{{ modalErrorMessage }}</div>
        <div class="form-group" id="userManagement-formGroup-username">
          <label for="username" id="userManagement-username">{{ 'USERNAME' | translate }}</label>
          <input class="form-control"
                 name="input-username"
                 type="text"
                 id="username"
                 v-model="currentUser.username"
                 :disabled="usernameFieldDisabled"
                 required>
        </div>
        <div class="form-group" id="userManagement-formGroup-email">
          <label for="email" id="userManagement-email">{{ 'EMAIL' | translate }}</label>
          <input class="form-control"
                 name="input-email"
                 type="email"
                 id="email"
                 v-model="currentUser.email"
                 required>
        </div>
        <div class="form-group" id="userManagement-formGroup-firstname">
          <label for="firstName" id="userManagement-firstname">{{ 'FIRST_NAME' | translate }}</label>
          <input class="form-control"
                 name="input-firstName"
                 type="text"
                 id="firstName"
                 v-model="currentUser.firstName"
                 required>
        </div>
        <div class="form-group" id="userManagement-formGroup-lastname">
          <label for="lastName" id="userManagement-lastname">{{ 'LAST_NAME' | translate }}</label>
          <input class="form-control"
                 name="input-lastName"
                 type="text"
                 id="lastName"
                 v-model="currentUser.lastName"
                 required>
        </div>
        <div class="mt-4 text-right" id="userManagement-buttonDiv">
          <button class="btn btn-link" @click="showCreateEditDialog = false" id="userManagement-buttonClose">
            {{ 'CLOSE' | translate }}
          </button>
          <button class="btn btn-primary" @click="addNewUser()" v-if="currentUser.id == null" :disabled="!isFilled" id="userManagement-buttonAddUser">
            {{ 'ADD_USER' | translate }}
          </button>
          <button class="btn btn-success" @click="editUser()" v-if="currentUser.id != null" :disabled="!isFilled" id="userManagement-buttonSaveChanges">
            {{ 'SAVE_CHANGES' | translate }}
          </button>
        </div>
      </form>
    </vodal>

    <vodal :show="showDeleteConfirmationDialog" animation="rotate" :width="deleteConfirmationDialogWidth"
           @hide="showDeleteConfirmationDialog = false" v-bind:closeOnEsc="true"
           v-bind:customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}" id="userManagement-deleteDialog">
      <h5>{{ 'SURE_DELETE_USER' | translate('msg') }}</h5>
      <table class="table-delete-user mt-4" id="userManagement-deleteTable">
        <tbody id="userManagement-deleteTableBody">
          <tr>
            <td class="text-right"><strong>{{ 'USERNAME' | translate }}:</strong></td>
            <td>{{ currentUser.username }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>{{ 'EMAIL' | translate }}:</strong></td>
            <td>{{ currentUser.email }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>{{ 'NAME' | translate }}:</strong></td>
            <td>{{ currentUser.firstName + ' ' + currentUser.lastName }}</td>
          </tr>
        </tbody>
      </table>
      <div class="mt-4 text-right" id="userManagement-deleteDialog-Buttons">
        <button class="btn btn-link" @click="showDeleteConfirmationDialog = false" id="userManagement-deleteDialog-Close-btn">{{ 'CLOSE' | translate }}</button>
        <button class="btn btn-danger" @click="deleteUser()" id="userManagement-deleteDialog-delete-btn">{{ 'DELETE' | translate }}</button>
      </div>
    </vodal>

    <vodal :show="showEditRolesDialog" animation="rotate" :width="editRolesDialogWidth"
           @hide="showEditRolesDialog = false" v-bind:closeOnEsc="true"
           v-bind:customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}" id="userManagement-EditDialog">
      <h4>{{ 'EDIT_ROLES_USER' | translate }} ({{ theClient.clientId }}):</h4>
      <table class="table-delete-user mt-4" id="userManagement-editTableDialog">
        <tbody>
          <tr>
            <td class="text-right"><strong>{{ 'USERNAME' | translate }}:</strong></td>
            <td>{{ currentUser.username }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>{{ 'EMAIL' | translate }}:</strong></td>
            <td>{{ currentUser.email }}</td>
          </tr>
          <tr>
            <td class="text-right"><strong>{{ 'NAME' | translate }}:</strong></td>
            <td>{{ currentUser.firstName + ' ' + currentUser.lastName }}</td>
          </tr>
        </tbody>
      </table>
      <div class="wrapper mt-3" id="userManagement-editRoles">
        <div class="column" id="userManagement-editAvailableRoles">
          <strong>{{ 'AVAILABLE_ROLES' | translate }}</strong>
          <ul class="list-unstyled mt-2" id="userManagement-editAvailableRoles-UL">
            <li v-for="(availableRole, index) in allAvailableRoles"
                v-if="!isRoleGrantedToUser(availableRole, currentUser)"
                class="roleSelector"
                v-on:click="addRoleToUser(availableRole, currentUser)" id="userManagement-editAvailableRoles-LI">
              <span :id="'userManagement-editAvailableRoles-'+ availableRole.name">{{availableRole.name}}</span>
              <i class="fa fa-arrow-right float-right text-success" :id="'userManagement-editAvailableRoles-'+availableRole.name + '-Arrow'"></i>
            </li>
          </ul>
        </div>
        <div class="column" id="userManagement-editAssignedRoles">
          <strong>{{ 'GRANTED_ROLES' | translate }}</strong>
          <ul class="list-unstyled mt-2" id="userManagement-editAssignedRoles-UL">
            <li v-for="(userRole, index) in userRoles[currentUser.username]"
                class="roleSelector"
                v-on:click="removeRoleFromUser(userRole, currentUser)" id="userManagement-editAssignedRoles-LI">
              <i class="fa fa-arrow-left text-danger" :id="'userManagement-editAssignedRoles-'+userRole.name + '-Arrow'"></i>
              <span :id="'userManagement-editAssignedRoles-'+ userRole.name">{{userRole.name}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="alert alert-success alert-dismissible" v-if="successMessageForRolesDialog">
        {{ successMessageForRolesDialog }}
        <button type="button" class="close" @click="dismissAlertSuccess()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="mt-4 text-right" id="userManagement-buttonCloseDiv">
        <button class="btn btn-link" @click="showEditRolesDialog = false" id="userManagement-close-btn">{{ 'CLOSE' | translate }}</button>
      </div>

    </vodal>
  </div>
</template>

<script>
    import Vodal from 'vodal';
    import UserManagementService from '../../service/UserManagementService';
    import PaginationList from '@/components/search/PaginationList';
    import CustomSpinner from '../CustomSpinner.vue';

    const DEFAULT_UM_PAGE_SIZE = 10;
    const DEFAULT_UM_PAGE = 1;
    const FILTERED_USER_MAX_FETCH = 1000;

    export default {
      props: {
        page: {default: DEFAULT_UM_PAGE},
        page_size: {default: DEFAULT_UM_PAGE_SIZE}
      },
      components: {
        'vodal': Vodal,
        'pagination-list': PaginationList,
        CustomSpinner
      },

      data() {
        return {
          userManagementService: new UserManagementService(),
          availableUsers: {},
          userRoles: {},
          theClient: {},
          showCreateEditDialog: false,
          showDeleteConfirmationDialog: false,
          showEditRolesDialog: false,
          addEditDialogWidth: 400,
          deleteConfirmationDialogWidth: 600,
          editRolesDialogWidth: 600,
          currentUser: {},
          currentUserRoles: [],
          allAvailableRoles: [],
          successMessage: null,
          errorMessage: null,
          errorObject: null,
          successMessageForRolesDialog: null,
          editUserRowIndex: null,
          modalErrorMessage: null,
          usernameFieldDisabled: false,
          loaded: false,
          currentPage: this.page,
          maxPerPage: this.page_size,
          userCount: null,
          filter: null,
          inSearchMode: false,
          oldFilter: null
        }
      },
      beforeMount() {
        this.init();
      },
      computed: {
        isFilled() {
          return this.currentUser.username &&
                 this.currentUser.email &&
                 this.currentUser.firstName &&
                 this.currentUser.lastName;
        },
        currentUserToLowerCase() {
          return {
            id: this.currentUser.id,
            username: this.currentUser.username.toLowerCase(),
            email: this.currentUser.email.toLowerCase(),
            firstName: this.currentUser.firstName,
            lastName: this.currentUser.lastName
          };
        }
      },
      methods: {
        init() {
          this.loaded = false;
          const vm = this;
          this.reloadUsers();
          this.userManagementService.getAllRoles().then((result) => {
            vm.allAvailableRoles = result;
          });
          this.userManagementService.getTheClient().then((result) => {
            vm.theClient = result;
          });
        },
        async reloadUsers() {
          this.loaded = false;
          // As the count API does not return filtered users count ,
          // we need to get the filtered users and count them ourselves when searching
          if (this.inSearchMode) {
            this.userCount = await this.userManagementService.getFilteredUserCount(FILTERED_USER_MAX_FETCH, this.filter)
              .catch(error => vm.onError('Error while loading users count : ' + error));
          } else {
            this.userCount = await this.userManagementService.getUserCount()
              .catch(error => vm.onError('Error while loading filtered users count : ' + error));
          }
          const vm = this;

          return new Promise((resolve, reject) => {
            vm.userManagementService.getUsers(vm.currentPage, vm.maxPerPage, this.filter).then((result) => {
              vm.availableUsers = result;
              vm.reloadAllUserRoles(vm.availableUsers).then((result) => {
                resolve(vm.availableUsers);
              }, (error) => {
                onerror(error);
              });
            }, (error) => {
              vm.onError(error);
              reject(error);
            });
          });
        },
        reloadUserRole (user) {
          const vm = this;
          return new Promise((resolve, reject) => {
            vm.userManagementService.getUserRoles(user.id).then((roles) => {
              var username = user.username;
              vm.$set(vm.userRoles, username, roles); // More about 'vm.$set' you can see here: https://vuejs.org/v2/guide/reactivity.html
              resolve(roles);
            }, (error) => {
              error.userManagementError = this.$options.filters.translate('UNABLE_LOAD_USER_ROLES', 'msg');
              reject(error);
            });
          });
        },
        reloadAllUserRoles(availableUsers) {
          const vm = this;
          return new Promise((resolve, reject) => {
            let promises = [];
            for (const u in availableUsers) {
              promises.push(vm.reloadUserRole(availableUsers[u], reject));
            }
            Promise.all(promises).then(result => {
              // we are setting everything as loaded when we finish loading the roles for all users
              vm.loaded = true;
            });
            resolve(vm.userRoles);
          });
        },
        getRolesAsString(roles) {
          var outRoles = '';
          for (var r in roles) {
            outRoles += roles[r].name;
            outRoles += ', '
          }
          if (outRoles) {
            return outRoles.slice(0, -2);
          }
          return outRoles;
        },
        addRoleToUser(role, user) {
          const vm = this;
          vm.userManagementService.addRoleToUser(role, user).then(() => {
            vm.userRoles[user.username].push(role);
            vm.setSuccessMessageForRolesDialog(this.$options.filters.translate('ROLE_GRANTED', 'msg') +
              ' ' + role.name + ' (' + user.username + ')');
          }, (error) => {
            vm.showEditRolesDialog = false;
            vm.onError(error);
          });
        },
        removeRoleFromUser(role, user) {
          const vm = this;
          vm.userManagementService.removeRoleFromUser(role, user).then(() => {
            vm.reloadUserRole(user);
            vm.setSuccessMessageForRolesDialog(this.$options.filters.translate('ROLE_REMOVED', 'msg') +
              ' ' + role.name + ' (' + user.username + ')');
          }, (error) => {
            vm.showEditRolesDialog = false;
            vm.onError(error);
          });
        },
        isRoleGrantedToUser(role, user) {
          var rolesOfAUser = this.userRoles[user.username];
          for (var r in rolesOfAUser) {
            if (rolesOfAUser[r].id === role.id) {
              return true;
            }
          }
          return false;
        },
        openCreateEditDialog(user, index) {
          this.showCreateEditDialog = true;
          this.modalErrorMessage = null;
          this.usernameFieldDisabled = false;
          if (user != null) {
            this.currentUser = Object.assign({}, user);
            this.editUserRowIndex = index;
            this.usernameFieldDisabled = true;
          } else {
            this.currentUser = {};
            this.editUserRowIndex = null;
          }
        },
        openDeleteConfirmationDialog(user) {
          this.showDeleteConfirmationDialog = true;
          this.currentUser = user;
        },
        openEditRolesDialog(user) {
          this.showEditRolesDialog = true;
          this.currentUser = user;
        },
        // CREATE USER:
        addNewUser() {
          if (this.validEmail(this.currentUserToLowerCase.email) === true) {
            const DEFAULT_USER_ROLE = 'user';
            var vm = this;
            this.showCreateEditDialog = false;
            this.loaded = false;
            this.$log.info(this.$options.filters.translate('ADDING_NEW_USER', 'msg') + ' ' + this.currentUserToLowerCase.username);
            let defaultRoles = this.allAvailableRoles.filter(role => role.name === DEFAULT_USER_ROLE);
            this.userManagementService.createUser(this.currentUserToLowerCase, defaultRoles).then((resp) => {
              vm.reloadUsers();
              vm.setSuccessMessage(this.$options.filters.translate('USER_CREATED', 'msg'));
              vm.currentUser = {};
            }, (err) => {
              vm.onError(err);
              vm.reloadUsers();
            });
          } else {
            this.setInvalidEmailErrorMessage();
          }
        },
        // UPDATE USER:
        editUser() {
          if (this.validEmail(this.currentUserToLowerCase.email) === true) {
            var vm = this;
            this.showCreateEditDialog = false;
            this.$log.info(this.$options.filters.translate('EDIT_USER', 'msg') + ' ' + this.currentUserToLowerCase.username);
            this.userManagementService.editUser(this.currentUserToLowerCase).then((resp) => {
              vm.setSuccessMessage(this.$options.filters.translate('USER_CHANGES_SAVED', 'msg'));
              if (vm.availableUsers[this.editUserRowIndex].id === this.currentUserToLowerCase.id) {
                vm.availableUsers[this.editUserRowIndex] = this.currentUserToLowerCase;
              } else {
                for (let user in vm.availableUsers) {
                  if (user.id === this.currentUserToLowerCase.id) {
                    user = this.currentUserToLowerCase;
                  }
                }
              }
              vm.currentUser = {};
              vm.editUserRowIndex = null;
            }, (err) => {
              vm.onError(err);
              vm.reloadUsers();
            });
          } else {
            this.setInvalidEmailErrorMessage();
          }
        },
        // DELETE USER:
        deleteUser() {
          var vm = this;
          vm.showDeleteConfirmationDialog = false;
          this.$log.info(this.$options.filters.translate('DELETE_USER', 'msg') + ' ' + this.currentUser.username);
          this.userManagementService.deleteUser(this.currentUser).then((resp) => {
            vm.setSuccessMessage(this.$options.filters.translate('USER_DELETED', 'msg'));
            vm.reloadUsers().then(() => {
              vm.currentUser = {};
            }, (error) => {
              vm.onError(error);
              vm.reloadUsers();
            });
          }, (err) => {
            vm.onError(err);
            vm.reloadUsers();
          });
        },
        checkForm(e) {
          e.preventDefault();
          if (this.currentUser.username && this.currentUser.username !== undefined &&
            this.currentUser.email && this.currentUser.email !== undefined && this.validEmail(this.currentUser.email) &&
            this.currentUser.firstName && this.currentUser.firstName !== undefined &&
            this.currentUser.lastName && this.currentUser.lastName !== undefined) {
            return true;
          }
          return false;
        },
        validEmail(email) {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(email).toLowerCase());
        },
        setInvalidEmailErrorMessage() {
          this.modalErrorMessage = this.$options.filters.translate('INVALID_EMAIL_ADDRESS', 'msg');
        },
        setSuccessMessage(message) {
          this.successMessage = message;
          this.errorObject = null;
          this.errorMessage = null;
          const vm = this;
          setTimeout(() => {
            vm.dismissAlertSuccess();
          }, 3000);
        },
        setSuccessMessageForRolesDialog (message) {
          this.successMessageForRolesDialog = message;
          const vm = this;
          setTimeout(() => {
            vm.dismissAlertSuccess();
          }, 3000);
        },
        dismissAlertSuccess() {
          this.successMessage = null;
          this.successMessageForRolesDialog = null;
        },
        onError(error) {
          this.errorObject = null;
          this.errorMessage = null;
          let errorMessage = null;
          if (error.response && error.response.data && error.response.data.errorMessage) {
            errorMessage = error.response.data.errorMessage;
          } else if (error.response && error.response.data) {
            errorMessage = error.response.data;
          } else if (error.response && error.response.statusText) {
            errorMessage = error.response.statusText;
          } else if (error.response) {
            errorMessage = error.response;
          } else {
            errorMessage = error;
          }
          if (errorMessage && error.userManagementError) { // prepend the specific user management part of the error message.
            errorMessage = error.userManagementError + ' ' + JSON.stringify(errorMessage);
          }
          if (errorMessage == null) { // if there was no expected message in the error response, than print the whole object.
            errorMessage = JSON.stringify(error);
          }
          this.errorMessage = errorMessage;
          this.$log.error(errorMessage);
        },
        dismissAlertError() {
          this.errorObject = null;
          this.errorMessage = null;
        },
        updateUrl: function() {
          this.$router.push('/admin/usersManagement' + this.buildUrl());
          this.$forceUpdate();
        },
        buildUrl: function() {
          let queryString = '';
          queryString += '?page=' + this.currentPage;
          if (this.maxPerPage !== DEFAULT_UM_PAGE_SIZE) {
            queryString += '&size=' + this.pageSize;
          }
          return queryString;
        },
        updateFilters: function (event) {
          if (this.oldFilter === this.filter) {
            return;
          }
          if (!this.filter && this.inSearchMode) {
            this.inSearchMode = false;
            this.searchUsersReload();
          } else if (event.key === 'Enter' || this.filter.length > 2) {
            this.inSearchMode = true;
            this.searchUsersReload();
          }
        },
        searchUsersReload() {
          // currentPage change will trigger users reload, so if we are already on page 1 we trigger it ourselves
          // we always go to page 1 as there is a change in state on the search field
          if (this.currentPage === 1) {
            this.reloadUsers();
            this.updateUrl();
          } else {
            this.currentPage = 1;
          }
          this.oldFilter = this.filter;
        }
      },
      watch: {
        currentPage: function() {
          this.reloadUsers();
          this.updateUrl();
        }
      }
    }
</script>

<style scoped>
  .users-table {
    table-layout: fixed;
  }
  .users-table td {
    word-break: break-word;
  }
  .btn {
    min-width: 80px;
  }
  .table-delete-user td {
    padding: 5px 8px;
  }
  .roleSelector .fa{
    visibility: hidden;
  }
  .roleSelector:hover .fa{
    visibility: visible;
    margin-top: 3px;
  }

  .roleSelector {
    padding-left: 10px;
    padding-right: 10px;
  }
  .roleSelector:hover {
    background-color:#d8e7ff;
    cursor: pointer;

  }
  .wrapper .column {
    float:left;
    width:250px;
    margin-left:30px;
  }
  .wrapper .column ul {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    padding: 10px;
  }
  .wrapper:after {
    content:'';
    display:block;
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/UserManagement.vue